<template>
    <div class="alert-container">
        <transition-group name="notifier" tag="div">
        <div v-for="item in items" :key="item.key" :class="[types[item.type].itemClass, options.closable ? 'alert-dismissible' : '']">
            <span v-if="options.useIcon" :class="types[item.type].iconClass" />
            <strong>{{ item.text }}</strong>
            <button type="button" class="close" v-if="options.closable" @click.stop.prevent="removeItem(item.key)">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        </transition-group>
    </div>
</template>

<script>
    export default {
        name: 'notifier',
        data: function() {
            return {
                options: {
                    closable: false,
                    useIcon: true,
                    timeout: 10000
                },
                types: {
                    info: { itemClass: 'alert alert-info', iconClass: 'fa fa-info-circle' },
                    danger: { itemClass: 'alert alert-danger', iconClass: 'fa fa-lg fa-exclamation-triangle' },
                    warning: { itemClass: 'alert alert-warning', iconClass: 'fa fa-lg fa-exclamation-circle' },
                    success: { itemClass: 'alert alert-success', iconClass: 'fa fa-lg fa-check-circle' }
                },
                items: {},
            };
        },
        methods: {
            addItem(type, text) {
                var key = new Date().getTime();
                this.$set(this.items, key, { type: type, text: text, key: key });
                //schedule remove
                if (this.options.timeout) {
                    setTimeout(() => { this.removeItem(key) }, this.options.timeout);
                }
            },
            removeItem(key) {
                this.$delete(this.items, key)
            },
            removeAll() {
                this.items = {};
            }
        },
        computed: {
            systemError() {
                return this.$store.state.errorNotification;
            }
        },
        watch: {
            systemError(val) {
                if (val) {
                    this.addItem("danger", val);
                    this.$store.dispatch('setErrorNotification', null);
                }
            }
        }
    };
</script>

<style scoped>
    .alert-container {
        position: fixed;
        right: 10px;
        top: 65px;
        z-index: 1000005;
    }
    .alert-container .alert > .fa {
        margin-right: 10px;
    }
    .alert-container .alert > .close {
        margin-left: 10px;
        font-size: 18px;
        background-color: transparent !important;
    }
    
    /* vue transition */
    
    /* moving */
    .notifier-move {
        opacity: 1;
        transition: all 0.5s;
    }
    /* appearing */
    .notifier-enter-active {
        transition: all 400ms ease-out;
    }
    /* disappearing */
    .notifier-leave-active {
        transition: all 400ms ease-in;
    }
    /* appear at / disappear to */
    .notifier-enter,
    .notifier-leave-to {
        opacity: 0;
        transform: scale(0);
    }
</style>